<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
    <page>
        <module enable-flex>
        <m-search ref="search" @search="searchHandle">
          <c-form>
            <c-form-item type="checkbox" name="state" :options="stateArray"></c-form-item>
          </c-form>
        </m-search>

        <m-operate>
          <c-button  icon="add"color="sys" @click="create()">添加</c-button>
          <c-button color="black" @click="openTypeManage()">分类管理</c-button>
        </m-operate>

        <c-table ref="table">
          <c-table-column
              label="状态"
              name="state"
              width="80"
          >
            <template v-slot="{data}">
              <span v-if="data.state == 2" style="color:darkgreen;">启用</span>
              <span v-if="data.state == 1" style="color:red;">禁用</span>
            </template>
          </c-table-column>

          <c-table-column
              label="分类"
              name="data_type_name"
              width="100"
          >
              <template v-slot="{data}">
                  <span v-if="data.data_type_name">
                      {{data.data_type_name}}
                  </span>
                  <span v-else>--</span>
              </template>
          </c-table-column>

         <c-table-column
                    label="封面图"
                    name="image"
          >
                <template v-slot="{data}">
                    <c-image v-if="data.image" :src="data.image" size="60"></c-image>
                    <span v-else>--</span>
                </template>
          </c-table-column>

          <c-table-column
              label="标题"
              name="title"
              width="250"
          >
          </c-table-column>

          <c-table-column
              label="主讲人"
              name="speaker"
              width="150"
          >
            <template v-slot="{data}">
              <span v-if="data.extra_data_map && data.extra_data_map.speaker">
                  {{data.extra_data_map.speaker}}
              </span>
              <span v-else>--</span>
            </template>
          </c-table-column>

          <c-table-column
              label="视频时长"
              name="duration"
          >
            <template v-slot="{data}">
                        <span v-if="data.extra_data_map && data.extra_data_map.video_duration_hour">
							{{data.extra_data_map.video_duration_hour}}时
						</span>
              <span v-if="data.extra_data_map && data.extra_data_map.video_duration_minute">
							{{data.extra_data_map.video_duration_minute}}分
						</span>
              <span v-if="data.extra_data_map && data.extra_data_map.video_duration_second">
							{{data.extra_data_map.video_duration_second}}秒
						</span>
            </template>
          </c-table-column>

          <c-table-column
              type="sort"
              label="排序"
              name="sort_id"
              @sort="sortHandle"
          >
          </c-table-column>

          <c-table-column
              type="button"
              fixed="right"
              label="操作"
              width="200"
          >
            <template v-slot="{data}">
              <c-table-button @click="edit(data)">编辑</c-table-button>
              <c-table-button @click="del(data)">删除</c-table-button>
              <c-table-button v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
              <c-table-button v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
            </template>
          </c-table-column>
        </c-table>
      </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑阿尔塔有约' : '添加阿尔塔有约'" width="850" height="600" @resolve="submitForm">
            <c-form ref="editForm">
            <c-form-item type="hidden" name="id"></c-form-item>
            <c-form-item type="hidden" name="language_type"></c-form-item>
            <c-form-item type="select" label="分类" name="data_type_id" :options="aertaDateTypeOption"></c-form-item>
            <c-form-item type="image" label="封面图" name="image" file-word="建议尺寸：600×400px"></c-form-item>
            <c-form-item type="input" label="标题" name="title" required></c-form-item>
            <c-form-item type="datetime" date-type="datetime" label="发布时间" name="publish_date" readonly required></c-form-item>
            <c-form-item type="input" label="主讲人" name="speaker" required></c-form-item>
            <c-form-item type="video" label="视频" name="video" required file-word="建议尺寸：16：9或4：3"></c-form-item>
            <c-form-item type="number" label="视频时长" decimal="0" :limit="[0,9999999]" name="video_duration_hour" input-unit="时"></c-form-item>
            <c-form-item type="number" label="视频时长" decimal="0" :limit="[0,9999999]" name="video_duration_minute" input-unit="分"></c-form-item>
            <c-form-item type="number" label="视频时长" decimal="0" :limit="[0,9999999]" name="video_duration_second" input-unit="秒"></c-form-item>
        </c-form>
        </c-dialog>

        <c-dialog ref="typeDialog" title="阿尔塔有约分类管理" width="800" :button="false">

            <m-operate>
                <c-button color="sys" @click="openAddTypeDia" power="m_aerta_date_list">新增分类</c-button>
            </m-operate>

            <c-table ref="typeTable" height="500">
                <c-table-column
                        label="分类名称"
                        name="title"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortTypeHandle"
                        width="120"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="170"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="openEditTypeDia(data)">编辑</c-table-button>
                        <c-table-button @click="deleteTypeHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="typeEdit" :title="editState ? '编辑阿尔塔有约分类' : '新增阿尔塔有约分类'" width="600" @resolve="editTypeHandle">
            <c-form ref="typeForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="hidden" name="language_type"></c-form-item>
                <c-form-item type="input" label="分类名称" name="title" required></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
export default {
    name: 'm_aerta_date_list',

    props: {
        languageType: Number        //2=英文  1=中文
    },

    data() {
        return {
            currentTime:'',
            stateArray: [
                {name: '禁用',value:1},
                {name: '启用',value:2}
            ],
            languageArray: [
                {name: '中文',value:1},
                {name: '英文',value:2}
            ],
            languageOption:[
                {name: '中文',value: 1},
                {name: '英文',value: 2}
            ],
            aertaDateTypeOption:[],
            editState: false
        }
    },

    watch: {
        languageType() {
            this.$refs.search.search();
        },
    },

    mounted() {
        this.getDateTypeOption();
        this.getCurrentTime();
        this.$refs.search.search();
    },

    methods: {
        //查询分类信息
        getDateTypeOption(){
              this.request({
                url: '/website/aerta_date_type/list',
                data: {
                  pageSize:99,
                  language_type:this.languageType
                },
                success: data => {
                  this.aertaDateTypeOption = Array.from(data, item => {
                    return {
                      name: item.title,
                      value: item.id
                    }
                  });
                }
              });
        },

        getCurrentTime() {
            //获取当前时间并打印
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth()+1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            this.currentTime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
        },

        searchHandle(data) {
            data.language_type = this.languageType;
            this.$refs.table.load({
                url: '/website/aerta_date/list',
                dataFormatter: data => {
                    for(var i=0;i<data.length;i++){
                        var rowData = data[i];
                        if (rowData && rowData.extra_data_map && rowData.extra_data_map.data_type_id){
                            var obj = this.aertaDateTypeOption.find(item=>item.value == rowData.extra_data_map.data_type_id);
                            if (obj){
                                rowData.data_type_name = obj.name;
                                console.log(obj);
                            }
                        }
                    }
                    return data;
                },
                data
            });
        },

        sortHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData ={};
            if(type=='top' || type=='bottom'){
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if(type=='up'){
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if(type=='down'){
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/website/aerta_date/sort',
                data: submitData,
                loading: true,
                success: data => {
                    next();
                }
            });
        },

        sortTypeHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData ={};
            if(type=='top' || type=='bottom'){
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if(type=='up'){
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if(type=='down'){
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/website/aerta_date_type/sort',
                data: submitData,
                loading: true,
                success: data => {
                    next();
                }
            });
        },

        create() {
          this.editState = false;
          this.$refs.editForm.clear();
          this.$refs.editForm.set({
            language_type:this.languageType,
            content:' ',
            publish_date:this.currentTime
          });
          this.$refs.editDialog.open();
        },

        edit(val) {
            this.editState = true;
            this.$refs.editForm.clear();
            this.request({
                url: '/website/aerta_date/detail',
                data: {id:val.id},
                loading: true,
                success: data => {
                    this.getDateTypeOption();
                    this.$refs.editForm.set(data);
                    this.$refs.editDialog.open();
                }
            });
        },

        del(val) {
            this.$confirm({
                text: '确定要删除当前Banner吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/website/aerta_date/remove',
                        data: {id:val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        updateState(type,val) {
            this.$confirm({
                text: '确定要'+(type==2?'启用':'禁用')+'当前Banner数据？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/website/aerta_date/update_state',
                        data: {id:val.id,state:type},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        submitForm(stop) {
            stop();
            let submitUrl = '/website/aerta_date/add';
            if(this.editState){
                submitUrl = '/website/aerta_date/edit';
            }
            this.$refs.editForm.submit({
                url: submitUrl,
                rule: {
                    title: [{
                      type: 'empty',
                      word: '请填写标题'
                    }],
                    publish_date: [{
                        type: 'empty',
                        word: '请填写发布时间'
                    }],
                    video: [{
                      type: 'empty',
                      word: '请上传视频'
                    }]
                },
                dataFormatter: data => {
                  var extra_data_map = {};
                  extra_data_map.publish_date = data.publish_date||'';
                  extra_data_map.data_type_id = data.data_type_id||'';
                  extra_data_map.speaker = data.speaker||'';
                  extra_data_map.video_duration_hour = data.video_duration_hour||'';
                  extra_data_map.video_duration_minute = data.video_duration_minute||'';
                  extra_data_map.video_duration_second = data.video_duration_second||'';
                  data.extra_data_map = extra_data_map;
                  return data;
                },
                success:(data,res) => {
                    this.$message({
                        text: '操作成功',
                        icon: 'success'
                    });
                    this.$refs.table.update();
                    this.$refs.editDialog.close();
                },
            });
        },

        openTypeManage(){
            this.$refs.typeDialog.open();
            this.$refs.typeTable.load({
                url: '/website/aerta_date_type/list',
                data:{
                  "type":994,
                   language_type:this.languageType
                },
                dataFormatter: data => {
                    return data;
                }
            });
        },
        openAddTypeDia(){
            this.editState = false;
            this.$refs.typeEdit.open();
            this.$refs.typeForm.clear();
            this.$refs.typeForm.set({
                language_type:this.languageType
            });
        },

        openEditTypeDia(val){
            this.editState = true;
            this.$refs.typeForm.set(val);
            this.$refs.typeEdit.open();
        },

        deleteTypeHandle(val){
            this.$confirm({
                text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/website/aerta_date_type/remove',
                        data: {id:val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.typeTable.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        editTypeHandle(stop) {
            stop();
            this.$refs.typeForm.submit({
                url: this.editState ? '/website/aerta_date_type/edit' :'/website/aerta_date_type/add',
                rule: {
                    title: '请填写分类名称'
                },
                success: () => {
                    this.$refs.typeTable.update();
                    this.$refs.typeEdit.close();
                    //刷新分类下拉框
                    this.getDateTypeOption();
                }
            });
        }
    }
}
</script>